import apiService from "./api";

export interface AttendanceType {
	id: string;
	tenantId: string;
	code: string;
	label: string;
	mediumId?: string;
	guideId?: string;
	requiredFunctionId?: string;
	numberingMode: "INCREMENTAL" | "PRE_DEFINED";
	maxTickets?: number;
	tracksTime: boolean;
	hasQueue: boolean;
	sortOrder: number;
	isActive: boolean;
	createdAt: string;
	updatedAt: string;
	medium?: {
		id: string;
		firstName: string;
		lastName: string;
		nickname?: string;
	};
	guide?: { id: string; name: string };
	requiredFunction?: { id: string; name: string };
	_count?: { attendanceCards: number };
	attendanceCards?: {
		id: string;
		ritualType: { id: string; name: string };
	}[];
	options?: {
		id: string;
		category: "COMPLAINT" | "RESOURCE";
		label: string;
		fieldType: "CHECKBOX" | "CHECKBOX_WITH_TEXT" | "QUANTITY";
		sortOrder: number;
		isActive: boolean;
	}[];
}

export interface CreateAttendanceTypeData {
	code: string;
	label: string;
	mediumId?: string;
	guideId?: string;
	requiredFunctionId?: string;
	numberingMode?: "INCREMENTAL" | "PRE_DEFINED";
	maxTickets?: number;
	tracksTime?: boolean;
	hasQueue?: boolean;
}

export interface UpdateAttendanceTypeData {
	code?: string;
	label?: string;
	mediumId?: string | null;
	guideId?: string | null;
	requiredFunctionId?: string | null;
	numberingMode?: "INCREMENTAL" | "PRE_DEFINED";
	maxTickets?: number | null;
	tracksTime?: boolean;
	hasQueue?: boolean;
}

export interface FindAttendanceTypesParams {
	page?: number;
	limit?: number;
	search?: string;
	isActive?: boolean;
	numberingMode?: string;
	hasQueue?: boolean;
	ritualTypeId?: string;
	sortBy?: string;
	sortOrder?: "asc" | "desc";
}

export interface PaginatedAttendanceTypes {
	data: AttendanceType[];
	meta: {
		total: number;
		page: number;
		limit: number;
		pages: number;
	};
}

export default {
	async getAttendanceTypes(
		params?: FindAttendanceTypesParams
	): Promise<PaginatedAttendanceTypes> {
		const response = await apiService.get("/attendance-types", { params });
		return response;
	},

	async getAttendanceTypeById(id: string): Promise<AttendanceType> {
		const response = await apiService.get(`/attendance-types/${id}`);
		return response;
	},

	async createAttendanceType(
		data: CreateAttendanceTypeData
	): Promise<AttendanceType> {
		const response = await apiService.post("/attendance-types", data);
		return response;
	},

	async updateAttendanceType(
		id: string,
		data: UpdateAttendanceTypeData
	): Promise<AttendanceType> {
		const response = await apiService.put(`/attendance-types/${id}`, data);
		return response;
	},

	async toggleAttendanceTypeStatus(id: string): Promise<AttendanceType> {
		const response = await apiService.patch(
			`/attendance-types/${id}/toggle-active`
		);
		return response;
	},

	async deleteAttendanceType(id: string): Promise<AttendanceType> {
		const response = await apiService.delete(`/attendance-types/${id}`);
		return response;
	},

	async getActiveAttendanceTypes(): Promise<AttendanceType[]> {
		const response = await apiService.get("/attendance-types", {
			params: { isActive: true, limit: 100 },
		});
		return response.data;
	},

	async getAttendanceTypeStats(): Promise<{
		total: number;
		active: number;
		inactive: number;
	}> {
		const response = await apiService.get("/attendance-types/stats");
		return response;
	},
};
